import u from "./_baseGet.js";
function f(e, r, t) {
  var n = e == null ? void 0 : u(e, r);
  return n === void 0 ? t : n;
}
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/get.js
// module id = 315
// module chunks = 67